/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_Age_TodayInputs */

const vi_einvoice_pending_age_today = /** @type {(inputs: Einvoice_Pending_Age_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hôm nay`)
};

/**

* @param {Einvoice_Pending_Age_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_age_today = /** @type {((inputs?: Einvoice_Pending_Age_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_Age_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_age_today(inputs)
});